"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ButtonVariants = void 0;
const react_1 = __importDefault(require("react"));
const rebass_1 = require("rebass");
const styled_components_1 = __importStar(require("styled-components"));
var ButtonVariants;
(function (ButtonVariants) {
    ButtonVariants["default"] = "default";
    ButtonVariants["primary"] = "primary";
    ButtonVariants["dark"] = "dark";
    ButtonVariants["warning"] = "warning";
    ButtonVariants["danger"] = "danger";
    ButtonVariants["outline"] = "outline";
    ButtonVariants["link"] = "link";
    ButtonVariants["success"] = "success";
    ButtonVariants["info"] = "info";
})(ButtonVariants = exports.ButtonVariants || (exports.ButtonVariants = {}));
function default_1(_a) {
    var { children, variant = ButtonVariants.primary, iconAfter, iconBefore, loading } = _a, rest = __rest(_a, ["children", "variant", "iconAfter", "iconBefore", "loading"]);
    return loading ? (react_1.default.createElement(rebass_1.Button, Object.assign({ variant: variant }, rest, { css: { width: 100, textAlign: 'center', justifyContent: 'center' }, disabled: true }),
        react_1.default.createElement(Spin, null))) : (react_1.default.createElement(rebass_1.Button, Object.assign({ variant: variant }, rest, { css: {} }),
        react_1.default.createElement(IconBefore, null, iconBefore),
        react_1.default.createElement(Text, null, children),
        react_1.default.createElement(IconAfter, null, iconAfter)));
}
exports.default = default_1;
const Text = styled_components_1.default.span `
    line-height: 0px;
`;
const IconBefore = styled_components_1.default.span `
    padding-right: 5px;
    line-height: 0;
`;
const IconAfter = styled_components_1.default.span `
    padding-left: 5px;
    line-height: 0;
`;
const spin = styled_components_1.keyframes `
    from {
        transform: rotate(0deg);
    }
    to {
        transform: rotate(360deg);
    }
`;
const Spin = styled_components_1.default.div `
    animation: ${spin} 1s linear infinite;
    border: 3px solid rgba(255, 255, 255, 0.5);
    border-top: 3px solid #fff;
    border-radius: 50%;
    width: 16px;
    height: 16px;
`;
//# sourceMappingURL=index.js.map